import React from 'react';
import FigmaBadge from '../../../../Elements/FigmaBadge';
import { getAutomaticInvoiceBadge } from '../../../../Helpers/invoiceAutomationStatusHelper';

// The "Automatic" chip of an invoice the automation made, coloured by its project's setup; nothing for an invoice a
// person made.
export default function AutomaticInvoiceChip({ isActive = null }) {
  const badge = getAutomaticInvoiceBadge(isActive);
  if (badge === null) {
    return null;
  }

  return (
    <FigmaBadge
      variant={badge.variant}
      label={badge.label}
      tooltip={badge.tooltip}
    />
  );
}
